// extracted by mini-css-extract-plugin
module.exports = {"sizeAdjust":"MaxBarGraph_sizeAdjust_12jju","graph_y_label":"MaxBarGraph_graph_y_label_3lySt","graph_x_label":"MaxBarGraph_graph_x_label_JMSCp"};